import { p as proxyCustomElement, H, h } from './p-bfa0dc67.js';
import { c as classNames } from './p-df8c8ec2.js';

const biListItemCss = ".sr-only{position:absolute;height:1px;width:1px;padding:0;margin:-1px;overflow:hidden;border:0;left:-9999px;text-indent:-5000px;clip:rect(1px, 1px, 1px, 1px);}*,*:before,*:after{box-sizing:border-box}html,body,div,span,object,iframe,figure,h1,h2,h3,h4,h5,h6,p,blockquote,pre,a,code,em,img,small,strike,strong,sub,sup,tt,b,u,i,ol,ul,li,fieldset,form,label,table,caption,tbody,tfoot,thead,tr,th,td,main,canvas,embed,footer,header,nav,section,button,video{margin:0;padding:0;border:0;font-size:100%;font:inherit;vertical-align:baseline;text-rendering:optimizeLegibility;-webkit-font-smoothing:antialiased;text-size-adjust:none}footer,header,nav,section,main{display:block}body{line-height:1.5}ol,ul{list-style:none}blockquote,q{quotes:none}blockquote:before,blockquote:after,q:before,q:after{content:\"\";content:none}table{border-collapse:collapse;border-spacing:0}input{-webkit-appearance:none;appearance:none;border-radius:0}:host(:focus){outline:none !important;border:none !important}:host{width:100%;display:flex}ul,li{margin-block-start:unset;margin-block-end:unset;padding-inline-start:unset;list-style:none;padding-top:4px;width:100%;display:flex}ul a,li a{text-decoration:none;color:inherit}a:focus-visible{border-radius:4px;outline-offset:2px;outline:1.5px solid var(--bi-primary-50);box-shadow:0 0 0 2px white}li.list-item.left{align-self:start}li.list-item.center{justify-content:center;margin:auto}li.list-item.right{align-self:end}";
const BiListItemStyle0 = biListItemCss;

const BiListItem$1 = /*@__PURE__*/ proxyCustomElement(class BiListItem extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        /**
         * Alignment of the list item
         * @default 'center'
         */
        this.alignment = 'left';
    }
    render() {
        const hasSrOnlyText = this.srOnly !== undefined && this.srOnly !== '';
        return (h("li", { class: classNames('list-item', this.alignment), key: this.itemKey, role: 'listitem', "aria-labelledby": hasSrOnlyText ? 'sr' + this.itemKey : null }, hasSrOnlyText ? (h("span", { class: 'sr-only', id: 'sr' + this.itemKey }, this.srOnly)) : null, h("slot", { key: '26d45229d5c6697de0be347d066f5b9c9060130f' }, "Item content goes here")));
    }
    static get style() { return BiListItemStyle0; }
}, [1, "bi-list-item", {
        "itemKey": [1, "item-key"],
        "srOnly": [1, "sr-only"],
        "alignment": [1]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["bi-list-item"];
    components.forEach(tagName => { switch (tagName) {
        case "bi-list-item":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, BiListItem$1);
            }
            break;
    } });
}

const BiListItem = BiListItem$1;
const defineCustomElement = defineCustomElement$1;

export { BiListItem, defineCustomElement };
